import * as z from 'zod';

import { brandedId, LoanInvestorRemittanceSplitId } from '../BrandedIds';
import { zodJSPlainDate } from '../dates/BrandedDate';

/** For fees, charges, advances etc */
export const InvestorRemittanceSplit = z.object({
  splitEnabled: z.boolean(),
  investor: z.number().nonnegative(),
  servicer: z.number().nonnegative(),
});
export type InvestorRemittanceSplit = z.infer<typeof InvestorRemittanceSplit>;

export const DEFAULT_IR_SPLIT: InvestorRemittanceSplit = {
  splitEnabled: false,
  investor: 0,
  servicer: 100,
};

/** Same as above, but contains additional ownership information for the loan level only */
export const LoanInvestorRemittanceSplit = InvestorRemittanceSplit.extend({
  // Stable id; defaulted to a fresh UUID when absent so legacy records get a stable id on the
  // next snapshot parse-and-rewrite (typically via the daily recalculateDerivedFields cron).
  id: LoanInvestorRemittanceSplitId.default(() => brandedId('LoanInvestorRemittanceSplitId')),
  investor2: z.number().nonnegative().optional(),
  investorOwnership: z.number().nonnegative().optional(),
  investor2Ownership: z.number().nonnegative().optional(),
  guaranteeFee: z.number().nonnegative().optional(),
  startDate: zodJSPlainDate.optional(), // Represents the payment date that interest starts being paid to the new investor
  soldDate: zodJSPlainDate.optional(), // Represents the sold date and when the principal starts being paid to the new investor
});
export type LoanInvestorRemittanceSplit = z.infer<typeof LoanInvestorRemittanceSplit>;
